import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`q-theme-toggle ${className}`}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Activar modo día' : 'Activar modo noche'}
      title={isDark ? 'Modo día' : 'Modo noche'}
    >
      {isDark ? <Sun size={17} strokeWidth={1.5} /> : <Moon size={17} strokeWidth={1.5} />}
    </button>
  );
};

export default ThemeToggle;
